import React from 'react';

import { BasicCard } from '../../../components';

const ExportReportCard = ({ onClickCallback, subtitle, title }) => {
  return (
    <BasicCard
      variant="secondary"
      header={{
        className: 'text-center text-color-primary-dark',
        icon: 'document-type-thin',
        iconSize: 'xxl',
        text: 'XLSX'
      }}
      body={{ title, subtitle, className: 'text-center' }}
      onClick={onClickCallback}
    />
  );
};

export default ExportReportCard;
